import React, { useEffect, useState, useRef } from "react";
import styles from "./style.module.css";

function getTextWidth(text, font) {
  var canvas =
    getTextWidth.canvas ||
    (getTextWidth.canvas = document.createElement("canvas"));
  var context = canvas.getContext("2d");
  context.font = font;
  var metrics = context.measureText(text);
  return metrics.width;
}

export default function InputWithPostfix(props) {
  const { value, required, id, placeholder, onChange, options } = props;
  const { postfix, minimum, maximum, postfixClass } = options;
  const inputRef = useRef(null);
  const postfixRef = useRef(null);
  const [inputValue, setInputValue] = useState(value ?? "");

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    if (newValue <= maximum) {
      setInputValue(newValue);
      onChange(newValue);
    }
  };

  useEffect(() => {
    const inputElement = inputRef.current;
    const suffixElement = postfixRef.current;

    const updateSuffix = () => {
      const width = getTextWidth(inputElement.value, "14px Agrandir, sans-serif");
      suffixElement.style.left = width + 10 + "px";
      suffixElement.style.visibility = inputElement.value
        ? "visible"
        : "hidden"; // Show/hide based on input value 
    };

    const handleInput = (e) => {
      const max = e.target.max;
      const val = e.target.value;
      if (val <= max) {
        updateSuffix();
      }
    };

    inputElement.addEventListener("input", handleInput);

    updateSuffix();

    return () => {
      inputElement.removeEventListener("input", handleInput);
    };
  }, [inputValue]);

  useEffect(() => {
    setInputValue(value ?? "");
  }, [value]);

  return (
    <div className={styles.inputWithPostfix}>
      <input
        type={"number"}
        value={inputValue}
        onChange={handleInputChange}
        required={required}
        placeholder={placeholder}
        className={styles.passwordInput}
        id={id}
        ref={inputRef}
        min={minimum}
        max={maximum}
      />
      <div className={`${styles.postfix} ${postfixClass}`} ref={postfixRef}>
        {postfix}
      </div>
    </div>
  );
}


// reminderPercentage: {
//   "ui:widget": InputWithPostfix,
//   "ui:classNames": `${formStyles.form_field} ${formStyles.col_12}`,
//   "ui:placeholder": "10%",
//   "ui:options": {
//     postfix: "%",
//     minimum: 1,
//     maximum: 100,
//   },
// },